import { SMARTCONNECTORS_PATHNAME } from '__pages/SmartConnectors/constants';
import { Redirect } from 'react-router-dom';
import { SubrouteComponent } from '../types';

export const Builder: SubrouteComponent = ({ smartConnector }) => {
  return (
    <Redirect to={`${SMARTCONNECTORS_PATHNAME}/${smartConnector.id}/builder`} />
  );
};
